import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useScroll } from '../hooks/useScroll';
import { useBloco, urlWhatsapp } from '../content';

export default function Navbar() {
  const nav = useBloco('global.nav');
  const WHATSAPP_URL = urlWhatsapp('comercial');
  const scrolled = useScroll();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const alwaysScrolled = pathname !== '/';
  const isScrolled = scrolled || alwaysScrolled;

  // Fecha o menu ao trocar de rota
  useEffect(() => { setMenuOpen(false); }, [pathname]);

  // Bloqueia o scroll do body quando o drawer está aberto
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  // Âncoras da home funcionam de qualquer rota
  const goTo = (hash) => (e) => {
    e.preventDefault();
    setMenuOpen(false);
    if (pathname === '/') {
      document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' }), 300);
    }
  };

  return (
    <nav className={`navbar-hidroativa ${isScrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
      <Link
        to="/"
        className="brand d-flex align-items-center gap-2 text-decoration-none"
        style={{ color: 'inherit' }}
        onClick={() => {
          // Já na home: garante voltar ao topo (a rota não muda, então ScrollToTop não dispara)
          if (pathname === '/') window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      >
        <img src="/LOGOHIDROATIVA.png" alt="HidroAtiva Engenharia" className="navbar-brand-logo" width="52" height="52" decoding="async" />
      </Link>

      <ul className="nav-links-desktop d-none d-md-flex list-unstyled mb-0 gap-4">
        {nav.links.map((l) => (
          <li key={l.to}><NavLink to={l.to} className="nav-link-custom">{l.label}</NavLink></li>
        ))}
        <li><a href="#contato" className="nav-link-custom" onClick={goTo('contato')}>{nav.contactLabel}</a></li>
      </ul>

      <a
        href={WHATSAPP_URL}
        target="_blank" rel="noopener noreferrer"
        className="nav-cta d-none d-md-inline-flex"
      >
        {nav.cta}
      </a>

      {/* Botão hamburger — só aparece no mobile */}
      <button
        type="button"
        className="nav-toggle d-md-none"
        aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((v) => !v)}
      >
        <span className="nav-toggle-bar" />
        <span className="nav-toggle-bar" />
        <span className="nav-toggle-bar" />
      </button>

      {/* Overlay + drawer mobile */}
      <div
        className={`nav-overlay ${menuOpen ? 'show' : ''}`}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />
      <div className={`nav-drawer ${menuOpen ? 'show' : ''}`} role="dialog" aria-modal="true">
        <ul className="list-unstyled mb-0">
          {nav.links.map((l) => (
            <li key={l.to}><NavLink to={l.to} className="nav-drawer-link">{l.label}</NavLink></li>
          ))}
          <li><a href="#contato" className="nav-drawer-link" onClick={goTo('contato')}>{nav.contactLabel}</a></li>
        </ul>
        <a
          href={WHATSAPP_URL}
          target="_blank" rel="noopener noreferrer"
          className="nav-cta nav-drawer-cta"
          onClick={() => setMenuOpen(false)}
        >
          {nav.cta}
        </a>
      </div>
    </nav>
  );
}
